import * as React from "react";

const SvgLiveStreaming = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M1505 5106 c-16 -7 -57 -42 -90 -77 -487 -521 -548 -1321 -148 -1916
71 -105 189 -239 227 -257 103 -49 216 21 216 134 0 51 -10 69 -87 153 -149
163 -264 400 -304 627 -19 106 -16 345 5 445 52 240 159 450 321 624 55 60 65
80 65 134 0 105 -109 175 -205 133z"
      />
      <path
        d="M3483 5100 c-30 -15 -48 -34 -62 -64 -37 -76 -24 -120 69 -222 344
-380 420 -937 189 -1396 -54 -107 -103 -179 -194 -284 -87 -99 -98 -132 -69
-202 25 -60 71 -92 131 -92 61 0 90 18 167 102 178 195 306 446 368 725 19 84
22 129 22 313 0 201 -1 223 -28 335 -60 259 -164 466 -337 672 -38 45 -83 91
-100 104 -45 31 -104 35 -156 9z"
      />
      <path
        d="M1845 4666 c-62 -27 -181 -180 -237 -305 -94 -205 -105 -475 -30
-691 51 -147 165 -315 251 -367 98 -61 221 10 221 128 0 49 -7 62 -89 161 -95
115 -136 245 -129 418 4 99 9 126 36 195 18 46 55 109 85 148 98 128 97 127
97 176 0 61 -29 107 -83 131 -49 23 -81 24 -122 6z"
      />
      <path
        d="M3155 4666 c-71 -31 -110 -120 -82 -187 8 -19 37 -61 66 -94 131
-152 181 -365 131 -559 -24 -97 -65 -173 -140 -265 -72 -88 -82 -129 -50 -196
36 -74 117 -103 193 -71 93 38 238 266 288 451 33 118 33 346 1 465 -31 116
-99 249 -177 348 -89 112 -153 142 -230 108z"
      />
      <path
        d="M2418 4421 c-250 -80 -386 -357 -296 -600 43 -116 122 -202 233 -256
312 -153 665 68 665 416 0 213 -148 402 -351 448 -69 16 -187 12 -251 -8z
m222 -302 c72 -40 100 -138 64 -215 -47 -99 -181 -119 -260 -40 -106 106 -35
275 115 276 26 0 58 -8 81 -21z"
      />
      <path
        d="M485 2718 c-83 -15 -189 -73 -255 -137 -67 -66 -123 -169 -140 -260
-6 -34 -10 -391 -10 -965 0 -993 -1 -965 57 -1086 34 -70 141 -177 213 -212
125 -62 -18 -58 2201 -58 1307 0 2045 4 2080 10 130 24 270 125 337 241 70
124 67 70 67 1109 0 1003 1 973 -52 1088 -35 74 -149 189 -223 225 -122 60
-12 57 -2210 56 -1221 -1 -2035 -5 -2065 -11z m4100 -299 c55 -15 101 -52 128
-102 l22 -42 3 -880 c2 -615 -1 -895 -9 -933 -13 -63 -55 -117 -114 -143 -38
-18 -127 -19 -2049 -19 -1558 0 -2018 3 -2050 12 -52 16 -108 72 -124 124 -9
31 -12 258 -12 935 0 849 1 896 19 934 24 51 68 93 117 110 33 12 366 14 2034
15 1413 0 2007 -3 2035 -11z"
      />
      <path
        d="M786 2120 c-16 -5 -40 -19 -54 -32 -53 -49 -52 -38 -52 -725 0 -622
0 -638 21 -679 15 -31 32 -48 63 -63 40 -20 60 -21 347 -21 269 0 308 2 339
18 107 53 107 211 0 264 -30 16 -65 18 -252 18 l-218 0 0 559 0 558 -22 33
c-44 65 -107 90 -172 70z"
      />
      <path
        d="M1784 2110 c-25 -12 -49 -35 -62 -59 -22 -39 -22 -40 -22 -686 0
-713 -2 -691 62 -736 72 -52 179 -25 218 55 20 43 20 52 18 694 -3 639 -3 651
-24 678 -51 68 -122 89 -190 54z"
      />
      <path
        d="M2314 2111 c-51 -23 -84 -74 -84 -129 0 -34 326 -1143 376 -1280 40
-108 207 -127 267 -30 8 13 101 311 207 662 185 616 192 640 180 680 -17 55
-65 102 -116 110 -51 9 -117 -16 -144 -54 -11 -15 -70 -193 -131 -396 -61
-203 -115 -375 -118 -382 -4 -7 -58 156 -121 362 -62 207 -121 390 -132 406
-19 32 -86 70 -123 70 -11 0 -38 -9 -61 -19z"
      />
      <path
        d="M3540 2107 c-84 -44 -80 -6 -80 -740 0 -712 -2 -693 61 -738 l34 -24
370 -3 c337 -2 373 -1 405 15 107 55 107 212 0 265 -31 16 -68 18 -302 18
l-268 0 0 195 0 195 228 0 c202 0 231 2 262 19 107 56 107 210 0 263 -30 16
-66 18 -262 18 l-228 0 0 120 0 120 280 0 c302 0 310 1 359 54 19 20 26 40 28
84 5 72 -19 115 -80 142 -39 18 -69 20 -403 20 -356 0 -361 0 -404 -23z"
      />
    </g>
  </svg>
);

export default SvgLiveStreaming;
